"use client"

import { useState } from "react"
import { NpEmailSignupFeedback } from "src/components/np-design/sections/newsletter/NpEmailSignupFeedback"
import { BackInStockSignupForm } from "src/components/product-details/buyBox/backInStock/BackInStockSignupForm"
import { useEventCallback } from "src/hooks/useEventCallback"

export type BackInStockSubcriptionButtonProps = {
  sku: string
}

export const BackInStockSubcriptionButton = ({ sku }: BackInStockSubcriptionButtonProps) => {
  const [success, setSuccess] = useState(false)
  const onSuccess = useEventCallback(() => setSuccess(true))

  if (success) {
    return (
      <NpEmailSignupFeedback
        heading="Du bist angemeldet."
        message="Wir benachrichtigen dich, sobald das Produkt wieder verfügbar ist."
      />
    )
  }

  return <BackInStockSignupForm sku={sku} onSuccess={onSuccess} />
}
